import utils from './helpers/FunctionsHelpers';

const BASE_API = process.env.REACT_APP_API_URL;
const auth = process.env.REACT_APP_BEARER;

function getUserId() {
  try {
    const stored = sessionStorage.getItem('token');
    if (stored) {
      const obj = JSON.parse(stored);
      if (obj && obj.user && obj.user.user_id != null) return String(obj.user.user_id);
    }
  } catch (e) {}
  return '';
}

const _fetch = window.fetch;
window.fetch = function (url, options = {}) {
  const urlStr = typeof url === 'string' ? url : (url && url.url);
  if (urlStr && BASE_API && urlStr.startsWith(BASE_API)) {
    const uid = getUserId();
    if (uid) {
      options = {
        ...options,
        headers: { ...(options.headers || {}), 'X-User-Id': uid }
      };
    }
  }
  return _fetch.call(this, url, options);
};

export default {
  viacep: async (cep) => {
    try {
      const req = await fetch(`https://viacep.com.br/ws/${cep}/json`, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      
      if (!req.ok) {
        throw new Error(`HTTP error! status: ${req.status}`);
      }
      
      const json = await req.json();
      return json;
    } catch (e) {
      console.log(e);
      throw e;
    }
  },

  validateLogin: async (username, password) => {
    const req = await fetch(`${BASE_API}/login/validateNew`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ username, password })
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loginByAppToken: async (appToken) => {
    const req = await fetch(`${BASE_API}/login/loginByAppToken`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${appToken}`,
      },
    }).catch(e => {
      console.log(e);
      return null;
    });

    if (!req) {
      return { token: null, messages: { error: 'Não foi possível processar esta requisição' } };
    }

    const json = await req.json();
    return json;
  },

  changePassword: async (postData) => {
    const req = await fetch(`${BASE_API}/login/changePassword`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  resetPassword: async (postData) => {
    const req = await fetch(`${BASE_API}/login/resetPassword`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  // Admin

  saveEvent: async (formData) => {
    const req = await fetch(`${BASE_API}/admin/SetEvent`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getClientEvent: async (clientId) => {
    const req = await fetch(`${BASE_API}/admin/getClientEvent/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteEvent: async (clientId) => {
    const req = await fetch(`${BASE_API}/admin/deleteEvent/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteNC: async (maintenance_id) => {
    const req = await fetch(`${BASE_API}/admin/deleteNC/${maintenance_id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteC: async (maintenance_id) => {
    const req = await fetch(`${BASE_API}/admin/deleteC/${maintenance_id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getRelatPerMonth: async (formData) => {
    const req = await fetch(`${BASE_API}/admin/getRelatPerMonth`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  filterRelatPerMonth: async (orgId = null) => {
    const req = await fetch(`${BASE_API}/admin/getFilterRelatPerMonth/${orgId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  // End Admin

  // Users

  getUserInfo: async (userId) => {
    const req = await fetch(`${BASE_API}/user/getUserInfo/${userId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  toggleUserSituation: async (userId) => {
    const req = await fetch(`${BASE_API}/user/toggleUserSituation/${userId}`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  mfaSetup: async (postData) => {
    const req = await fetch(`${BASE_API}/user/mfaSetup`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  mfaActivate: async (postData) => {
    const req = await fetch(`${BASE_API}/user/mfaActivate`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  mfaDisable: async (postData) => {
    const req = await fetch(`${BASE_API}/user/mfaDisable`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  verifyMfa: async (postData) => {
    const req = await fetch(`${BASE_API}/login/verifyMfa`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getGroup: async () => {
    const req = await fetch(`${BASE_API}/user/getGroup`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveUser: async (postData) => {
    const req = await fetch(`${BASE_API}/user/saveUser`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  updUserInfo: async (postData) => {
    const req = await fetch(`${BASE_API}/user/updUserInfo`, {
      method: 'PUT',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });

    const json = await req.json();
    return json;
  },

  listUser: async (postData) => {
    const req = await fetch(`${BASE_API}/user/listUser`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setUserAccess: async (postData) => {
    const req = await fetch(`${BASE_API}/user/setUserAccess`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getUserClient: async (userId) => {
    const req = await fetch(`${BASE_API}/user/getUserClient/${userId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getUnityId: async (userId) => {
    const req = await fetch(`${BASE_API}/user/getUnityId/${userId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getClientOrgs: async (userId) => {
    const req = await fetch(`${BASE_API}/user/getClientOrgs/${userId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listOperators: async () => {
    const req = await fetch(`${BASE_API}/user/listOperators`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //End Users

  siteNotices: async (days, siteId) => {
    const req = await fetch(`${BASE_API}/notify`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ days, site: siteId }),
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadBuilding: async (buildingId) => {
    const req = await fetch(`${BASE_API}/buildings/index/${buildingId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveBuilding: async (postData) => {
    const req = await fetch(`${BASE_API}/buildings/setBuilding`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  // ORGANIZATION
  listAllOrganizations: async () => {
    const req = await fetch(`${BASE_API}/clients/getAllOrganization`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listOrganizations: async () => {
    const req = await fetch(`${BASE_API}/clients/getOrganization`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listResponsableDepartment: async () => {
    const req = await fetch(`${BASE_API}/clients/listResponsableDepartment`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getOrganization: async (orgId) => {
    if (orgId) {
      const req = await fetch(`${BASE_API}/clients/getOrganization/${orgId}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth}`,
          'Content-Type': 'application/json',
        },
      }).catch(e => {
        console.log(e);
      });
      const json = await req.json();
      return json;
    }

    return "[]";
  },

  getUnitysNCopenedIots: async (orgId, userId) => {
    const req = await fetch(`${BASE_API}/clients/getUnitysNCopenedIots/${orgId}/${userId}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listOrganizationClients: async (orgId, subOrgId = null, includeInactive = false) => {
    let url = `${BASE_API}/organizations/getClientList/${orgId}`;
    if (subOrgId) {
      url += `/${subOrgId}`;
    }
    if (includeInactive) {
      url += subOrgId ? `/true` : `/null/true`;
    }

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listOrganizationClientsResponsible: async (orgId, userAccess) => {
    const req = await fetch(`${BASE_API}/organizations/getClientResponsibleList/${orgId}/${userAccess}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveOrganization: async (postData) => {
    const req = await fetch(`${BASE_API}/clients/setOrganization`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadOrganization: async (orgId) => {
    const req = await fetch(`${BASE_API}/clients/getOrganization/${orgId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setLogoFile: async (formData) => {
    const req = await fetch(`${BASE_API}/organizations/setLogoFile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  downloadLogo: async (id) => {
    const req = await fetch(`${BASE_API}/organizations/downloadFile/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
    }).catch(e => {
      console.log(e);
    });
    if (req.status == 200) {
      const blob = await req.blob();
      return blob;
    } else {
      return false;
    }
  },

  getClientListGeralRiskNoteLastsMonths: async (orgId, subOrgId = null) => {
    const url = subOrgId
      ? `${BASE_API}/organizations/getClientListGeralRiskNoteLastsMonths/${orgId}/${subOrgId}` 
      : `${BASE_API}/organizations/getClientListGeralRiskNoteLastsMonths/${orgId}`;

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getSubClients: async (orgId, onlyActive = false) => {
    const req = await fetch(`${BASE_API}/organizations/getSubClients/${orgId}?only_active=${onlyActive}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getIssuesReport: async (postData, rOrg = false) => {
    const urlComplement = (rOrg) ? "getIssuesReport" : "getUnitIssuesReport";

    const req = await fetch(`${BASE_API}/organizations/${urlComplement}`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
      body: postData
    }).catch(e => {
      console.log(e);
    });
    const blob = await req.blob();
    return blob;
  },

  getInspectionReport: async (postData) => {
    const req = await fetch(`${BASE_API}/organizations/getUnitPDFInspection`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
      body: postData
    }).catch(e => {
      console.log(e);
    });

    const blob = await req.blob();
    return blob;
  },

  getUnitPDFConformities: async (postData) => {
    const req = await fetch(`${BASE_API}/organizations/getUnitPDFConformities`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
      body: postData
    }).catch(e => {
      console.log(e);
    });

    const blob = await req.blob();
    return blob;
  },

  getDetailedNCsReport: async (postData) => {
    const req = await fetch(`${BASE_API}/organizations/getUnitPDFDetailedNCs`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
      body: postData
    }).catch(e => {
      console.log(e);
    });

    const blob = await req.blob();
    return blob;
  },

  listOrgSuborganizations: async (client_id, type) => {
    const req = await fetch(`${BASE_API}/organizations/getSuborganizations/${client_id}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listOrgAvailableSuborganizations: async (client_parent) => {
    const req = await fetch(`${BASE_API}/organizations/getOrgAvailableSuborganizations/${client_parent}`, {
      method: 'GET',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
        console.log(e);
    });

    const json = await req.json();
    return json;
  },

  saveSuborganization: async (data) => {
    const req = await fetch(`${BASE_API}/organizations/saveSuborganization`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  changeSttsSuborganization: async (id, situation_id) => {
    const req = await fetch(`${BASE_API}/organizations/changeSttsSuborganization/${id}/${situation_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END ORGANIZATION

  // CLIENT

  listHeadquarters: async () => {
    const req = await fetch(`${BASE_API}/clients/getHeadquarters`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientTypes: async () => {
    const req = await fetch(`${BASE_API}/clients/getTypes`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientsParents: async () => {
    const req = await fetch(`${BASE_API}/clients/parents`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveClient: async (postData) => {
    const req = await fetch(`${BASE_API}/clients/setClient`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadClient: async (cliId) => {
    const req = await fetch(`${BASE_API}/clients/getClient/${cliId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientAddresses: async (cliId) => {
    const req = await fetch(`${BASE_API}/clients/getClientAddress/${cliId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveAddress: async (postData) => {
    const req = await fetch(`${BASE_API}/clients/setAddress`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientBuildings: async (cliId) => {
    const req = await fetch(`${BASE_API}/buildings/getBuilding/${cliId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientSectors: async (client_id, type) => {
    const req = await fetch(`${BASE_API}/clients/getSectors/${client_id}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadClientPanel: async (clientId) => {
    const req = await fetch(`${BASE_API}/clients/getPanel/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadClientNC: async (postData) => {
    const req = await fetch(`${BASE_API}/clients/getClientMaintenance`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ client_id: postData.client_id, sys: postData.sys, date_initial: postData.dt_ini, date_finish: postData.dt_fim })
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadClientDocument: async (clientId, daysBefore) => {
    const req = await fetch(`${BASE_API}/clients/getClientDocuments/${clientId}/${daysBefore}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadClientEvent: async (clientId, daysBefore) => {
    const req = await fetch(`${BASE_API}/clients/getClientEvents/${clientId}/${daysBefore}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getChild: async (clientId) => {
    const req = await fetch(`${BASE_API}/clients/getChild/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  editStatusBuilding: async (id, situation_id) => {
    const req = await fetch(`${BASE_API}/buildings/editStatusBuilding/${id}/${situation_id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  editStatusOrganization: async (id, situation_id) => {
    const req = await fetch(`${BASE_API}/clients/editStatusOrganization/${id}/${situation_id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getStatusOrganization: async (id) => {
    const req = await fetch(`${BASE_API}/clients/verificaStatusOrganization/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getUnitysParents: async (client_id) => {
    const req = await fetch(`${BASE_API}/clients/getParentUnitys/${client_id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteBuilding: async (id) => {
    const req = await fetch(`${BASE_API}/clients/deleteBuilding/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END CLIENT

  // OCUPATION

  listOcupationTypes: async () => {
    const req = await fetch(`${BASE_API}/ocupation/list`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END OCCUPATION

  // STATES

  listStates: async () => {
    const req = await fetch(`${BASE_API}/states/list`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END STATES

  // CITIES

  listCities: async () => {
    const req = await fetch(`${BASE_API}/cities/list`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END CITIES

  // SYSTEMS

  listSystemsTypes: async (clientId) => {
    const req = await fetch(`${BASE_API}/system/getSystemType/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientSystemsTypes: async (clientId) => {
    const req = await fetch(`${BASE_API}/system/getClientSystemType/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientActiveSystemsTypes: async (clientId) => {
    const req = await fetch(`${BASE_API}/system/getClientActiveSystemType/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveProtectionSystem: async (siteId, catId, active, id) => {
    const req = await fetch(`${BASE_API}/system/saveProtectionSystem`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ client_id: siteId, system_type_id: catId, situation_id: active, system_id: id })
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveProtectionSystemActive: async (postData) => {
    const req = await fetch(`${BASE_API}/system/saveProtectionSystemActive`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveInspectionSystemActive: async (postData) => {
    const req = await fetch(`${BASE_API}/system/saveInspectionSystemActive`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveInspectionSystemResponsable: async (postData) => {
    const req = await fetch(`${BASE_API}/system/saveInspectionSystemResponsable`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listMaintenanceTypes: async (sysId, sysIdInspRep = null) => {
    const url = sysIdInspRep 
      ? `${BASE_API}/system/getMaintenanceType/${sysId}/${sysIdInspRep}` 
      : `${BASE_API}/system/getMaintenanceType/${sysId}`;
    
    const req = await fetch(url, {
      method: 'GET',
      headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
        console.log(e);
    });

    const json = await req.json();
    return json;
  },

  saveMaintenance: async (postData) => {
    const req = await fetch(`${BASE_API}/system/setMaintenance`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveMaintenanceAccording: async (postData) => {
    const req = await fetch(`${BASE_API}/system/setMaintenanceAccording`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveConclusion: async (formData) => {
    const req = await fetch(`${BASE_API}/system/setConclusion`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setMaintenanceFile: async (formData) => {
    const req = await fetch(`${BASE_API}/system/setMaintenanceFile`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  downloadMaintenanceAccording: async (id) => {
    try {
      const req = await fetch(`${BASE_API}/system/downloadFileAccording/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth}`,
          'Accept': 'application/pdf, image/*, application/json'
        },
      });

      if (!req.ok) {
        throw new Error(`HTTP error! status: ${req.status}`);
      }

      const res = await req.json();
      const data = atob(res.data);
      const mimeType = res.mimeType;

      const byteCharacters = atob(res.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      //returns file and props
      return { blob, mimeType, url: res.url };
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  downloadMaintenance: async (id) => {
    try {
      const req = await fetch(`${BASE_API}/system/downloadFile/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth}`,
          'Accept': 'application/pdf, image/*, application/json'
        },
      });

      if (!req.ok) {
        throw new Error(`HTTP error! status: ${req.status}`);
      }

      const res = await req.json();
      const data = atob(res.data);
      const mimeType = res.mimeType;

      const byteCharacters = atob(res.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      //returns file and props
      return { blob, mimeType, url: res.url };
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  downloadConcluded: async (id) => {
    try {
      const req = await fetch(`${BASE_API}/system/downloadConcluded/${id}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${auth}`,
          'Accept': 'application/pdf, image/*, application/json'
        },
      });

      if (!req.ok) {
        throw new Error(`HTTP error! status: ${req.status}`);
      }

      const res = await req.json();
      const data = atob(res.data);
      const mimeType = res.mimeType;

      const byteCharacters = atob(res.data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      const blob = new Blob([byteArray], { type: mimeType });

      //returns file and props
      return { blob, mimeType, url: res.url };
    } catch (e) {
      console.log(e);
      return null;
    }
  },

  loadMaintenance: async (issueId) => {
    const req = await fetch(`${BASE_API}/system/getMaintenance/${issueId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  loadMaintenanceAccording: async (issueId) => {
    const req = await fetch(`${BASE_API}/system/getMaintenanceAccording/${issueId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listMaintenanceAll: async (data) => {
    const req = await fetch(`${BASE_API}/system/getMaintenanceAll`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: data
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listCompliancesAll: async (data) => {
    const req = await fetch(`${BASE_API}/system/getCompliancesAll`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: data
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getFilterCsNCs: async (data) => {
    const req = await fetch(`${BASE_API}/system/getFilterCsNCs`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: data
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getTotalMaintenanceOpen: async (orgId, type, subOrgId = null) => {
    const url = subOrgId
      ? `${BASE_API}/system/getTotalMaintenanceOpen/${orgId}/${type}/${subOrgId}` 
      : `${BASE_API}/system/getTotalMaintenanceOpen/${orgId}/${type}`;

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getGroupSystemMaintenanceOpen: async (orgId = null, type, subOrgId = null, user_id = null) => {
    let url;

    if (utils.isNullOrEmpty(orgId)) {
      if(!utils.isNullOrEmpty(user_id)){
        url = `${BASE_API}/system/getGroupSystemMaintenanceOpen/null/null/null/${user_id}`;
      }else{
        url = `${BASE_API}/system/getGroupSystemMaintenanceOpen`;
      }
    } else {
      url = subOrgId
      ? `${BASE_API}/system/getGroupSystemMaintenanceOpen/${orgId}/${type}/${subOrgId}`
      : `${BASE_API}/system/getGroupSystemMaintenanceOpen/${orgId}/${type}`;
    }

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getRiskNoteLastMonths: async (client_id, client_parent) => {
    const req = await fetch(`${BASE_API}/system/getRiskNoteLastMonths/${client_id}/${client_parent}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getAllRiskNoteLastMonths: async (client_parent, suborganization_id = null) => {
    const url = suborganization_id
      ? `${BASE_API}/system/getAllRiskNoteLastMonths/${client_parent}/${suborganization_id}` 
      : `${BASE_API}/system/getAllRiskNoteLastMonths/${client_parent}`;

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getRiskNoteSystemLastMonths: async (client_id, type, suborganization_id = null) => {
    const url = suborganization_id
      ? `${BASE_API}/system/getRiskNoteSystemLastMonths/${client_id}/${type}/${suborganization_id}` 
      : `${BASE_API}/system/getRiskNoteSystemLastMonths/${client_id}/${type}`;

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listPavements: async (clientId) => {
    const req = await fetch(`${BASE_API}/system/listPavements`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listAreas: async (clientId) => {
    const req = await fetch(`${BASE_API}/system/listAreas`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveSectorAreaPavement: async (data) => {
    const req = await fetch(`${BASE_API}/system/saveSectorAreaPavement`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  changeSttsAreaPavement: async (id, situation_id) => {
    const req = await fetch(`${BASE_API}/system/changeSttsAreaPavement/${id}/${situation_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  closeMaintenance: async (data) => {
    const req = await fetch(`${BASE_API}/system/setConclusionAndWarning`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: data
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  reopenMaintenance: async (maintenance_id) => {
    const req = await fetch(`${BASE_API}/system/reopenMaintenance/${maintenance_id}`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END SYSTEMS

  // DOCUMENTS

  listDocumentTypes: async () => {
    const req = await fetch(`${BASE_API}/documents/getDocumentTypes`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientDocuments: async (clientId) => {
    const req = await fetch(`${BASE_API}/documents/clientDocument/${clientId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listClientDocumentsSpecifics: async (clientId, type) => {
    const req = await fetch(`${BASE_API}/documents/clientDocumentSpecific/${clientId}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveDocument: async (formData) => {
    const req = await fetch(`${BASE_API}/documents/saveDocument`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  renewDocument: async (formData) => {
    const req = await fetch(`${BASE_API}/documents/renewDocument`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveReplyDocument: async (formData) => {
    const req = await fetch(`${BASE_API}/documents/saveReplyDocument`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(formData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  downloadDocument: async (id) => {
    const req = await fetch(`${BASE_API}/documents/downloadFile/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/pdf',
      },
    }).catch(e => {
      console.log(e);
    });
    const blob = await req.blob();
    return blob;
  },

  deleteDocument: async (id) => {
    const req = await fetch(`${BASE_API}/documents/deleteDocument/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getDocInfosByNC: async (system_maintenance_id) => {
    const req = await fetch(`${BASE_API}/documents/getDocInfosByNC/${system_maintenance_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  closeMaintenanceDoc: async (data) => {
    const req = await fetch(`${BASE_API}/documents/setConclusionAndWarningNCdoc`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: data
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  //---- END DOCUMENTS

  // DASHBOARD

  saveReport: async (formData) => {
    const req = await fetch(`${BASE_API}/dashboard/saveReport`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveChat: async (formData) => {
    const req = await fetch(`${BASE_API}/dashboard/saveChat`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listVideos: async (active) => {
    const req = await fetch(`${BASE_API}/dashboard/listVideos/${active}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listTypeVideos: async () => {
    const req = await fetch(`${BASE_API}/dashboard/listTypeVideo`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  changeSttsVideo: async (id, situation_id) => {
    const req = await fetch(`${BASE_API}/dashboard/changeSttsVideo/${id}/${situation_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteVideo: async (id) => {
    const req = await fetch(`${BASE_API}/dashboard/deleteVideo/${id}`, {
      method: 'DELETE',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setVideo: async (postData) => {
    const req = await fetch(`${BASE_API}/dashboard/setVideo`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  listInspection: async () => {
    const req = await fetch(`${BASE_API}/dashboard/listInspection`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getInspectionSector: async (inspId) => {
    const req = await fetch(`${BASE_API}/dashboard/listInspectionSector/${inspId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getInspection: async (inspId) => {
    const req = await fetch(`${BASE_API}/dashboard/listInspection/${inspId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setInspection: async (postData) => {
    const req = await fetch(`${BASE_API}/dashboard/setInspection`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  listMqttIots: async (id = null, unitName = null, status = null, description = null) => {
    const params = new URLSearchParams();

    if (id !== null) params.append('id', id);
    if (unitName !== null) params.append('unitName', unitName);
    if (status !== null) params.append('status', status);
    if (description !== null) params.append('description', description);

    const req = await fetch(`${BASE_API}/dashboard/listMqttIots${params ? `?${params.toString()}` : ''}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  setMqttIot: async (postData) => {
    const req = await fetch(`${BASE_API}/dashboard/setMqttIot`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  sendMailResolvedNC: async (postData) => {
    const req = await fetch(`${BASE_API}/email/sendMailResolvedNC`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },
  
  sendMailOccurrence: async (postData) => {
    const req = await fetch(`${BASE_API}/email/sendMailOccurrence`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  sendMailChat: async (postData) => {
    const req = await fetch(`${BASE_API}/email/sendMailChat`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  sendPin: async (postData) => {
    const req = await fetch(`${BASE_API}/email/sendMailPinPassword`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  validatePin: async (postData) => {
    const req = await fetch(`${BASE_API}/email/validatePinPassword`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  editMaintenance: async (postData) => {
    const req = await fetch(`${BASE_API}/dashboard/editMaintenance`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(postData)
    }).catch(e => {
      console.log(e);
    })
    const json = await req.json();
    return json;
  },

  getAllCasIOTs: async (client_parent = null) => {
    const url = client_parent
      ? `${BASE_API}/dashboard/getAllCasIOTs/${client_parent}` 
      : `${BASE_API}/dashboard/getAllCasIOTs`;

    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getIOTs: async (client_id, type) => {
    const req = await fetch(`${BASE_API}/dashboard/getIOTs/${client_id}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getRelatIOTs: async (client_id, type) => {
    const req = await fetch(`${BASE_API}/dashboard/getRelatIOTs/${client_id}/${type}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getThermalCameras: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getThermalCameras/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getThermalCameraTemperature: async (client_id, camera_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getThermalCameraTemperature/${client_id}/${camera_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getRelatThermalCameras: async (client_id, camera_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getRelatThermalCameras/${client_id}/${camera_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaIOT: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaIOT/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaIOTGeneral: async (client_id, type_integration) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaIOTGeneral/${client_id}/${type_integration}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaDeltafireIOTAlarms: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaDeltafireIOTAlarms/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaDeltafireIOTEvents: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaDeltafireIOTEvents/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaDeltafireIOTRelatLast90Days: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaDeltafireIOTRelatLast90Days/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaIntelbrasIOTAlarms: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaIntelbrasIOTAlarms/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaIntelbrasIOTEvents: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaIntelbrasIOTEvents/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaIntelbrasIOTRelatLast90Days: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaIntelbrasIOTRelatLast90Days/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaGlobalSonicIOTAllEvents: async (client_id, events) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaGlobalSonicIOTAllEvents/${client_id}/${events}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCaGlobalSonicIOTRelatLast90Days: async (client_id) => {
    const req = await fetch(`${BASE_API}/dashboard/getCaGlobalSonicIOTRelatLast90Days/${client_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getIdentifiers: async (sysId) => {
    const req = await fetch(`${BASE_API}/system/getIdentifiers/${sysId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getAsksBySys: async (sysId) => {
    const req = await fetch(`${BASE_API}/system/getAsksBySys/${sysId}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getQtdTotalSys: async (system_id) => {
    const req = await fetch(`${BASE_API}/system/getQtdTotalSys/${system_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveCountSysTotal: async (qtd, sysId) => {
    const req = await fetch(`${BASE_API}/system/saveCountSysTotal`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ qtd_total: qtd, system_id: sysId })
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveCountSystem: async (arraySave, sysId) => {
    const req = await fetch(`${BASE_API}/system/saveCountSystem`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify({ sysArray: arraySave, sysId: sysId})
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getWarningList: async (maintenance_id) => {
    const req = await fetch(`${BASE_API}/system/getWarningList/${maintenance_id}`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getQuantTratativasOp: async (data) => {
    const req = await fetch(`${BASE_API}/system/getQuantTratativasOperador`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getCountTratativas: async () => {
    const req = await fetch(`${BASE_API}/system/getCountTratativas`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getSupervisaoMaintenance: async (data) => {
    const req = await fetch(`${BASE_API}/system/getMaintenanceSupervisao`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  listReportEmails: async (client_id, isManagement = false) => {
    let url = `${BASE_API}/clients/getReportEmail/${client_id}`;
    if (isManagement === true) {
      url += '/1';
    }
    const req = await fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteEmailReport: async (id) => {
    const req = await fetch(`${BASE_API}/clients/deleteEmailReport/${id}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  updateNotifyCloseNc: async (id, flag) => {
    const req = await fetch(`${BASE_API}/clients/updateNotifyCloseNc/${id}/${flag}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  updateNotifyWeeklyReport: async (id, flag) => {
    const req = await fetch(`${BASE_API}/clients/updateNotifyWeeklyReport/${id}/${flag}`, {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${auth}`,
        'Content-Type': 'application/json',
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  saveEmailReport: async (data) => {
    const req = await fetch(`${BASE_API}/clients/setReportEmail`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  export_datatable: async (data) => {
    const req = await fetch(`${BASE_API}/reports/datatable_pdf_download`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });

    if (req.ok) {
      const filename = utils.removerAcentuacao(data.title) + "_" + utils.formatDate(new Date(), 'dmy_His') + ".pdf";

      const blob = await req.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename); // Nome do arquivo
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link); // Remove o link após o download
    } else {
      console.log('Erro no download do PDF');
    }
  },

  validateSafetyListMaintenance: async (data) => {
    const req = await fetch(`${BASE_API}/system/validateSafetyListMaintenance`, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(data)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  getTypesValidationSafetyListMaintenance: async () => {
    const req = await fetch(`${BASE_API}/system/getTypesValidationSafetyListMaintenance`, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  // ISSUES
  deleteEvidence: async (formData) => {
    const req = await fetch(`${BASE_API}/issues/deleteEvidence`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: formData
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },
  // END ISSUES

  createMaintenanceSchedule: async (formData) => {
    const req = await fetch(`${BASE_API}/dashboard/insertMaintenanceSchedule`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(formData)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  deleteScheduleMaintenance: async (mqtt_id) => {
    const req = await fetch(`${BASE_API}/dashboard/deleteMaintenanceScheduleIOT/${mqtt_id}`, {
      method: 'DELETE',
      headers: {
        'Authorization': `Bearer ${auth}`,
      }
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  },

  batchDeleteScheduleMaintenance: async (listMqttIds) => {
    const req = await fetch(`${BASE_API}/dashboard/batchDeleteScheduleMaintenance`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth}`,
      },
      body: JSON.stringify(listMqttIds)
    }).catch(e => {
      console.log(e);
    });
    const json = await req.json();
    return json;
  }
}
